/**
 * Get the API base URL, ensuring it doesn't have /api suffix
 * @returns {string} The API base URL without trailing /api
 */
export const getApiBase = () => {
  let apiBase = process.env.REACT_APP_API_URL || '';
  
  // Remove trailing /api if present
  if (apiBase.endsWith('/api')) {
    apiBase = apiBase.slice(0, -4);
  }
  
  // Remove trailing slash
  apiBase = apiBase.replace(/\/$/, '');
  
  return apiBase;
};

/**
 * Build a full API URL from a path
 * @param {string} path - The API path (e.g., 'admin/login' or '/admin/login')
 * @returns {string} The full API URL
 */
export const buildApiUrl = (path) => {
  const apiBase = getApiBase();
  // Remove leading slash from path if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  
  if (!apiBase) {
    return `/${cleanPath}`;
  }
  
  return `${apiBase}/${cleanPath}`;
};
